import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import { logout } from "features/auth/authSlice";
import { clearClientView } from "features/clientView/clientViewSlice";
import { clearNotification } from "features/notificationSlice";
import { resetTopFolderZip } from "features/topFolderZipSlice";
import { resetBrowserZip } from "features/browserZipSlice";
import { resetPdfSplitJobs } from "features/pdfSplitJobsSlice";
import { clearTopFolderZipStorage } from "features/topFolderZipPersistence";
import { clearBrowserZipStorage } from "features/browserZipPersistence";
import { clearPdfSplitJobsStorage } from "features/pdfSplitJobsPersistence";
import { api } from "features/api";
import { apiWithAuth } from "features/auth/auth";

const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: isAnyOf(
    logout.match,
    apiWithAuth.endpoints.logout.matchFulfilled,
    apiWithAuth.endpoints.login.matchFulfilled,
    apiWithAuth.endpoints.checkAuth.matchRejected
  ),
  effect: async (action, listenerApi) => {
    if (logout.match(action)) {
      listenerApi.dispatch(clearClientView());
      listenerApi.dispatch(api.util.resetApiState());
      sessionStorage.removeItem("setEmailPromptDismissed");
      listenerApi.dispatch(resetTopFolderZip());
      listenerApi.dispatch(resetBrowserZip());
      listenerApi.dispatch(resetPdfSplitJobs());
      clearTopFolderZipStorage();
      clearBrowserZipStorage();
      clearPdfSplitJobsStorage();
    }
    if (apiWithAuth.endpoints.logout.matchFulfilled(action)) {
      listenerApi.dispatch(clearClientView());
      listenerApi.dispatch(api.util.resetApiState());
      sessionStorage.removeItem("setEmailPromptDismissed");
      listenerApi.dispatch(resetTopFolderZip());
      listenerApi.dispatch(resetBrowserZip());
      listenerApi.dispatch(resetPdfSplitJobs());
      clearTopFolderZipStorage();
      clearBrowserZipStorage();
      clearPdfSplitJobsStorage();
    }
    if (apiWithAuth.endpoints.checkAuth.matchRejected(action)) {
      sessionStorage.removeItem("setEmailPromptDismissed");
    }
    if (apiWithAuth.endpoints.login.matchFulfilled(action)) {
      // A different user may be logging in - drop the previous user's cache.
      listenerApi.dispatch(clearClientView());
      listenerApi.dispatch(api.util.resetApiState());
      listenerApi.dispatch(clearNotification());
    }
    localStorage.removeItem("folderMappings");
  },
});

export default listenerMiddleware;
